/** @jsx h **/
import { defineComponent, onMounted, onUnmounted, ref, inject, h } from "vue";

import { useSliding } from "@gratico/uikit";
import { ShellProps, ShellPropsList } from "@gratico/sdk";
import { CheckoutTree } from "./CheckoutTree";

export const NavIsland = defineComponent<ShellProps>({
  name: "NavIsland",
  props: [...ShellPropsList],
  setup(props, ctx) {
    // return null;
    const { sidebarRef, mouseEvent } = useSliding(undefined, -1);
    return () => (
      <div
        ref={sidebarRef}
        style={
          "top: 60px; bottom: 60px; width: 290px; left: 0; z-index: 21474836;"
        }
        class={
          "flex flex-col layered-bg absolute  left-0  border rounded  overflow-y-auto"
        }
      >
        <div class="pb-2">
          <CheckoutTree {...props} />
        </div>
      </div>
    );
  },
});
